module.exports = __webpack_public_path__ + "media/images/icons/quote-c72df94c57bc6733b5a048ee97ae3525.svg";